import './App.css';
import Navbar from './component/Navbar';
import Home from './pages/home';
import './style/style.css';
import Follower from './component/Follower'

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
</style>

function App() {
  const Follow = document.getElementById("Follow");

  document.body.onpointermove = event => {
      const { clientX, clientY } = event;

      Follow.animate({
          left: `${clientX}px`,
          top: `${clientY}px`
      }, {duration: 1000, fill: "forwards"})

  }
  return (
    <div className="App">
    <Follower/>
      <header className="App-header">
        <Navbar/>
      </header>
      <div id='Follow'></div>
      <Home/>
    </div>
  );
}

export default App;
